export default "__VITE_ASSET__e2e806b4__";